module.exports = __webpack_public_path__ + "img/missionaries27_2019_7-7-2021.49f6eb12.jpg";